import { o2oApi } from 'yxt-biz-pc/packages/api';
export const getTaskInfo = params => o2oApi.get('/study/next/evaluate/task', { params });

// 简单项目详情
export const getSimpleProjectInfo = (projectId) => {
  return o2oApi.get(`/study/stu/project/baseinfo/${projectId}`);
};
